module.exports = __webpack_public_path__ + "public/img/book_1.bb5d462b.png";